import { UPDATE_B2B_MIS_SUCCESS, UPDATE_B2B_MIS_REQUEST, UPDATE_B2B_MIS_FAILURE, UPDATE_B2B_MIS_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateB2BMisReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_B2B_MIS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPDATE_B2B_MIS_REQUEST:
            return Object.assign({}, state);
        case UPDATE_B2B_MIS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPDATE_B2B_MIS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default updateB2BMisReducer;
